import { apiService } from '../../shared/services/apiService';
import { AccessParams } from '../../shared/interfaces/AccessParams';

export type PasswordInfo = {
  password: string;
  repeatPassword: string;
};

export type ChangePasswordInfo = {
  currentPassword: string;
  password: string;
  repeatPassword: string;
};

type SetNewPasswordToUserResponse = { success: boolean };
type ChangePasswordResponse = { refresh_token: string };
type ChangePasswordConfig = { isRunGlobalSpinner?: boolean; ignoreErrorCodes?: number[] };

export const passwordService = {
  // used to set new password to user not logged in to system
  async setNewPasswordToUser(
    userId: number,
    passwordInfo: PasswordInfo,
    params?: { send_password?: boolean },
  ) {
    const resp = await apiService.put<SetNewPasswordToUserResponse>(
      `api/general/set-password/${userId}`,
      passwordInfo,
      { params },
    );

    return resp.data;
  },

  /** Logged-in user changes their own password (entity, coach). Requires current password. */
  async changePassword(
    passwordInfo: ChangePasswordInfo,
    config: ChangePasswordConfig = {},
  ) {
    const { isRunGlobalSpinner = false, ignoreErrorCodes } = config;
    const resp = await apiService.put<ChangePasswordResponse>(
      `api/general/change-password`,
      passwordInfo,
      { isRunGlobalSpinner, ignoreErrorCodes },
    );

    return resp.data;
  },

  /** SuperAdmin sends a password reset link to an entity's email. */
  async sendPasswordResetLink(entityId: number) {
    const resp = await apiService.post<undefined>(
      `api/entity/${entityId}/password-reset-link`,
    );

    return resp.data;
  },

  /** Public endpoint — called when a user sets their password via a magic link (email invite). No auth required. */
  async setPassword(accessParams: AccessParams, password: string) {
    const { hash, timestamp, token } = accessParams;

    const resp = await apiService.post(
      `/api/public/setpassword/${token}/${timestamp}/${hash}`,
      { password },
    );

    return resp.data;
  },
};
